import { AUTH_LOADING, AUTH_LOADED, NEW_USER, SIGN_IN_USER, SIGN_OUT_USER } from '../../constants';
import { IReduxAction } from '../../interfaces';
import firebase from '../../../firebase-integration';

import { loadUserDetails } from '../../users/actions';

export const signIn = (payload?: any): IReduxAction => ({
  payload,
  type: SIGN_IN_USER,
});

export const verifyAuth = (): any => {
  return function (dispatch: any) {
    return firebase.auth().onAuthStateChanged(async (user) => {
      dispatch(authLoading());
      if (user) {
        console.log(user);
        dispatch({ type: SIGN_IN_USER, payload: user });
        const userDetails = await loadUserDetails(user.uid);
        dispatch(userDetails);
        dispatch(authLoaded());
      } else {
        dispatch(signOut());
        dispatch(authLoaded());
      }
    });
  };
};

export const authLoading = (): IReduxAction => ({
  type: AUTH_LOADING,
});

export const authLoaded = (): IReduxAction => ({
  type: AUTH_LOADED,
});

export const newUser = (payload?: any): IReduxAction => ({
  payload,
  type: NEW_USER,
});

export const signOut = (payload?: any): IReduxAction => ({
  payload,
  type: SIGN_OUT_USER,
});
